export default "__VITE_ASSET__BpBa9UZ6__"